import * as fees from "./fees";
import * as formatting from "./formatting";

export const StripeUtils = {
    fees,
    formatting,
};
